import {
  ColumnFiltersState,
  getCoreRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable
} from '@tanstack/react-table';
import { getSegmentationRulesColumnDefs } from './client-integration-column-defs';
import { ClientIntegrationDTO } from '../clientIntegration.model';
import { CustomTable } from 'common/components/table/customTable';
import { useState } from 'react';
import {
  fuzzyFilter,
  multiSelectFilter
} from 'common/components/table/table-functions/filters';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import Button from 'common/components/buttons/button';
import { useSelector } from 'react-redux';
import { selectIntegrationMetaMap } from '../clientIntegration-meta-slice';

const ClientIntegrationTable = ({
  clientIntegrations
}: {
  clientIntegrations: ClientIntegrationDTO[];
}) => {
  const integrationMetaMap = useSelector(selectIntegrationMetaMap);

  const columnDefs = getSegmentationRulesColumnDefs(integrationMetaMap);

  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);

  const clientIntegrationTable = useReactTable({
    data: clientIntegrations,
    columns: columnDefs,
    filterFns: {
      fuzzy: fuzzyFilter,
      multiSelectFilter
    },
    state: {
      columnFilters
    },
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    enableColumnResizing: true,
    debugTable: false,
    debugHeaders: false,
    debugColumns: false
  });

  const handleResetFilters = () => {
    setColumnFilters([]);
  };

  return (
    <>
      <Button
        classOverrides="px-2 py-1.5"
        theme={ButtonTheme.SECONDARY}
        identifier="reset-exclusions-filter"
        onClick={handleResetFilters}
      >
        <div className="flex items-center justify-between">
          <i className="ra-icons-generic-filter text-sm mr-2 flex"></i>
          <span>Reset Filters</span>
        </div>
      </Button>{' '}
      <CustomTable
        key={`segmentation-rules-config-table`}
        componentId={'segmentation-rules-config-table'}
        table={clientIntegrationTable}
        cellClasses=""
      />
    </>
  );
};

export default ClientIntegrationTable;
